import { useEffect, useState } from 'react'
import { IUseContentCountry } from './types'

const useContentCountry = (): IUseContentCountry => {
    const [countryInfo, setCountryInfo] = useState<IUseContentCountry>({ isLoading: true })

    useEffect(() => {
        const sessionCountry = window?.sessionStorage?.getItem('dataContentCountry')
        const abortCtrl = new AbortController()
        let timer: number

        if (!sessionCountry) {
            Promise.race([
                fetch('/api/country', { signal: abortCtrl.signal }),
                new Promise((_, reject) => {
                    timer = window?.setTimeout(() => {
                        reject({})
                    }, 1000)
                }) as Promise<Response>,
            ])
                .then(res => {
                    if (res?.status === 200) {
                        return res?.text()
                    }
                    return Promise.reject()
                })
                .then((country: string) => {
                    setCountryInfo({ country, isLoading: false })
                    window?.sessionStorage?.setItem('dataContentCountry', country)
                })
                .catch(() => {})
                .finally(() => {
                    setCountryInfo(prev => ({ ...prev, isLoading: false }))
                })
        } else {
            setCountryInfo({ country: sessionCountry, isLoading: false })
        }

        return () => {
            clearTimeout(timer)
            abortCtrl.abort()
        }
    }, [])

    return countryInfo
}

export default useContentCountry
